/* eslint-disable @typescript-eslint/no-explicit-any */
export const downloadCsvFile = (response: any) => {
  const disposition = response.headers['content-disposition'];
  const fileName = disposition?.match(/filename="?(.+)"?/)?.[1] ?? 'file.csv';
  const url = window.URL.createObjectURL(
    new Blob([response.data], {
      type: 'text/csv',
    })
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export function downloadBlobAsFile(
  blob: Blob,
  headers?: Record<string, string>,
  defaultFilename = 'download.zip'
) {
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;

  // Optional: extract filename from Content-Disposition header
  let filename = defaultFilename;

  const disposition =
    headers?.['content-disposition'] || headers?.['Content-Disposition'];
  if (disposition) {
    const match = disposition.match(/filename="?(.+?)"?$/);
    if (match) {
      // eslint-disable-next-line prefer-destructuring
      filename = match[1];
    }
  }

  a.download = filename;

  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
